var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "our_suggestion" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "all_title_block right_title_block" }, [
        _c("div", { staticClass: "title_block" }, [
          _c("span", [_vm._v(_vm._s(_vm.$store.getters.t("Popular_posts")))]),
          _vm._v(" "),
          _c("div")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "blocks" },
        _vm._l(_vm.posts, function(post) {
          return _c("div", { key: post.id, staticClass: "block" }, [
            _c(
              "div",
              { staticClass: "img" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "blog.category.post",
                        params: {
                          lang: _vm.$store.getters.locale,
                          category: post.category_slug,
                          post: post.slug
                        }
                      }
                    }
                  },
                  [_c("img", { attrs: { src: post.photo } })]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text_block" }, [
              _c(
                "div",
                { staticClass: "name_block" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "blog.category.post",
                          params: {
                            lang: _vm.$store.getters.locale,
                            category: post.category_slug,
                            post: post.slug
                          }
                        }
                      }
                    },
                    [_vm._v(_vm._s(post.name))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { domProps: { innerHTML: _vm._s(post.short_content) } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "read_more" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "blog.category.post",
                          params: {
                            lang: _vm.$store.getters.locale,
                            category: post.category_slug,
                            post: post.slug
                          }
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$store.getters.t("Read_more")) + "...")]
                  )
                ],
                1
              )
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d075a71c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d075a71c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/widgets/ActivePosts.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d075a71c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/widgets/ActivePosts.vue
// module chunks = 0